import { createContext, useContext } from 'react'
import type { TLightboxContext } from '@/components/ui/Lightbox/types'

export const LightboxContext = createContext<TLightboxContext>({} as TLightboxContext)

export const useLightboxPageContext = () => useContext(LightboxContext)
